import {useEffect} from "react";
import {useGame} from "./useGame.js";
import {Lobby} from "./Lobby.jsx";
import {WaitingRoom} from "./WaitingRoom.jsx";
import {Board} from "./Board.jsx";
import {Phone} from "./Phone.jsx";

export function App({controller}) {
  const snapshot = useGame(controller);
  const {game, view} = snapshot;

  useEffect(() => {
    document.body.classList.toggle("view-board", view === "board");
    document.body.classList.toggle("view-hand", view === "hand");
  }, [view]);

  // Only the live surface is mounted. Hiding the others with [hidden] still ran their
  // effects and reconciled their trees on every notification — the board rebuilt its
  // event log once a second behind a phone that could not see it.
  const isWaiting = game?.status === "lobby";
  const isHandView = view === "hand";

  return (
    <main className="app">
      {!game && (
        <section className="lobby" aria-label="Lobby">
          <Lobby controller={controller} snapshot={snapshot} />
        </section>
      )}

      {game && (
        <section className="game" aria-label="Spel">
          {/* A phone mode — 1 mot 1 or 2 mot 2 — has no TV. Every device is a phone, so
              the waiting room is what the whole room sees before the match and the
              hand is all it sees during one; the board would be a second copy of a
              screen nobody is looking at. A device that somehow holds one of these
              without a seat still gets the board rather than a Phone with nobody to
              paint. Keying this on teams rather than on the mode left a 1 mot 1 lobby
              with no waiting room at all. */}
          {controller.isPhoneGame() ? (
            isWaiting
              ? <WaitingRoom controller={controller} snapshot={snapshot} />
              : (controller.myPlayer()
                ? <Phone controller={controller} snapshot={snapshot} />
                : <Board controller={controller} snapshot={snapshot} />)
          ) : (
            <>
              {!isHandView && (isWaiting
                ? <WaitingRoom controller={controller} snapshot={snapshot} />
                : <Board controller={controller} snapshot={snapshot} />)}
              {controller.myPlayer() && <Phone controller={controller} snapshot={snapshot} />}
            </>
          )}
        </section>
      )}
    </main>
  );
}
